import { useEffect, useRef, useState } from 'react'
import { Icon } from './Icon'
import { Logotype } from './Logotype'
import { linkWhatsApp } from '../config'

type Submenu = {
  rotulo: string
  itens: Array<{ texto: string; href: string }>
}

const SUBMENUS: Submenu[] = [
  {
    rotulo: 'Estruturação',
    itens: [
      { texto: 'Estruturação de iFood', href: '#plataformas' },
      { texto: 'Estruturação de 99 Food', href: '#plataformas' },
      { texto: 'Gestão contínua', href: '#ecossistema' },
    ],
  },
  {
    rotulo: 'Produtos',
    itens: [
      { texto: 'Relacionamento e Vendas', href: '#ecossistema' },
      { texto: 'Cardápio e Atendimento', href: '#ecossistema' },
      { texto: 'Operação e Gestão', href: '#ecossistema' },
      { texto: 'Planos', href: '#planos' },
    ],
  },
]

type Props = {
  grudado: boolean
  escondido: boolean
  menuAberto: boolean
  setMenuAberto: (v: boolean) => void
}

export function Header({ grudado, escondido, menuAberto, setMenuAberto }: Props) {
  // Guarda qual submenu esta aberto pelo indice; null = nenhum. Um so por vez.
  const [abertoIdx, setAbertoIdx] = useState<number | null>(null)
  const navRef = useRef<HTMLElement>(null)

  // Com o menu mobile aberto a pagina de tras nao pode rolar, senao o dedo
  // arrasta o conteudo embaixo do painel.
  useEffect(() => {
    document.body.classList.toggle('nav-open', menuAberto)
    document.body.style.overflow = menuAberto ? 'hidden' : ''
    return () => {
      document.body.classList.remove('nav-open')
      document.body.style.overflow = ''
    }
  }, [menuAberto])

  useEffect(() => {
    const aoClicarFora = (e: MouseEvent) => {
      const alvo = e.target as HTMLElement | null
      if (!alvo?.closest('.nav__drop')) setAbertoIdx(null)
    }
    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return
      setAbertoIdx(null)
      setMenuAberto(false)
    }
    document.addEventListener('click', aoClicarFora)
    document.addEventListener('keydown', aoTeclar)
    return () => {
      document.removeEventListener('click', aoClicarFora)
      document.removeEventListener('keydown', aoTeclar)
    }
  }, [setMenuAberto])

  const fecharTudo = () => {
    setAbertoIdx(null)
    setMenuAberto(false)
  }

  const classes = ['header', grudado && 'is-stuck', escondido && 'is-hidden'].filter(Boolean).join(' ')

  return (
    <header className={classes} id="header">
      <div className="shell header__inner">
        <a className="logo" href="#inicio" aria-label="Skyenex — página inicial">
          <span className="logo__mark">
            <img src="/assets/img/marca-skyenex.webp" alt="" width={256} height={256} />
          </span>
          <span className="logo__txt">
            <Logotype />
            <span className="logo__tagline">Tecnologia e gestão para restaurantes reais</span>
          </span>
        </a>

        <nav
          className={`nav${menuAberto ? ' is-open' : ''}`}
          id="nav"
          ref={navRef}
          aria-label="Navegação principal"
          onClick={(e) => {
            if ((e.target as HTMLElement).closest('a')) fecharTudo()
          }}
        >
          <a href="#inicio">Início</a>

          {SUBMENUS.map((menu, i) => (
            <div className={`nav__drop${abertoIdx === i ? ' is-open' : ''}`} key={menu.rotulo}>
              <button
                type="button"
                className="nav__toggle"
                aria-expanded={abertoIdx === i}
                onClick={(e) => {
                  e.stopPropagation()
                  setAbertoIdx(abertoIdx === i ? null : i)
                }}
              >
                {menu.rotulo} <span className="chev" />
              </button>
              <div className="nav__menu">
                {menu.itens.map((item) => (
                  <a href={item.href} key={item.texto}>{item.texto}</a>
                ))}
              </div>
            </div>
          ))}

          <a href="#sobre">Sobre</a>
          <a href={linkWhatsApp()} className="btn btn--wa nav__cta">
            <Icon name="wa" className="ico" /> Fale com um especialista
          </a>
        </nav>

        <a href={linkWhatsApp()} className="btn btn--wa header__cta">
          <Icon name="wa" className="ico" /> Fale com um especialista
        </a>

        <span className="header__script">Crescer é um prato bem servido.</span>

        <button
          className={`burger${menuAberto ? ' is-open' : ''}`}
          id="burger"
          aria-label="Abrir menu"
          aria-expanded={menuAberto}
          aria-controls="nav"
          onClick={() => setMenuAberto(!menuAberto)}
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  )
}
